import React, { useState, useEffect } from 'react';
import { IProps } from './types';
// import moment from 'moment';
import moment from 'moment-timezone';
import _ from 'lodash';
import { InsuredState, IFill2ndFormValue, IFill2ndState, KycInfo } from 'constants/models/components/insurProcess/insureProcessFill2nd';
import { ExpanFooterContent } from 'constants/models/evalExpans';
import { TravelWarningExpandData, FlightInfo, IFill1stFormValue } from 'constants/models/components/insurProcess/insureProcessFill1st';
import { TempCalc } from 'constants/models/components/insurProcess/insureProcess';
import commonService from 'utils/commonService';
import { PolicyAddReq } from 'bff/models/product';
import { YesNo } from 'constants/enums/yesNo.enum';
import storageService from 'utils/storageService';
import { storageKeys } from 'constants/enums/storageKeys.enum';
import environment from 'constants/environments';
import { OccupationIdType } from 'constants/enums/occupationIdType.enum';
import apiCommonService from 'bff/services/commonService';
import { ApplyType } from 'constants/enums/applyType.enum';
import { CodeId } from 'constants/enums/codeId.enum';
import sweetAlertService from 'utils/sweetAlertService';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';

const InsureProcessPreview: React.FC<IProps> = (props) => {
  const [tempTravels, setTempTravels] = useState<TravelWarningExpandData[]>();
  const [editedTempCalc, setEditedTempCalc] = useState<TempCalc>();
  const [planDataFooter, setPlanDataFooter] = useState<any>();
  const [tempFill2ndFormVal, setTempFill2ndFormVal] = useState<IFill2ndFormValue>();
  // const [flightInfos, setFlightInfos] = useState<FlightInfo[]>();
  const [tempFill1stFormVal, setTempFill1stFormVal] = useState<IFill1stFormValue>();

  useEffect(() => {
    commonService.scrollToTop();
  }, []);

  useEffect(() => {
    if (props.tempFill1st && props.tempFill1st.tempFill1stState && props.tempFill1st.tempFill1stFormVal) {
      setTempTravels({ ...props.tempFill1st.tempFill1stState.tempTravels });
      setEditedTempCalc({ ...props.tempFill1st. tempFill1stState.editedTempCalc });
      // setFlightInfos([...props.tempFill1st.tempFill1stFormVal.FLIGHT_INFOS]);
      setTempFill1stFormVal({ ...props.tempFill1st.tempFill1stFormVal });
    }

    if (props.tempFill2nd && props.tempFill2nd.tempFill2ndState && props.tempFill2nd.tempFill2ndFormVal) {
      setPlanDataFooter({ ...props.tempFill2nd?.tempFill2ndState?.planData?.FOOTER });
      setTempFill2ndFormVal({ ...props.tempFill2nd.tempFill2ndFormVal });
    }
  }, [props.tempFill1st, props.tempFill2nd]);

  /**
   * @description 點選下一步事件
  */
  const handleOnClick = async () => {
    if (props.tempFill2nd.tempFill2ndState?.applyType === ApplyType.WebRequire) {
      const isConfirm = await sweetAlertService.modal({
        title: commonService.getCodeMsg(props.UICode, CodeId.W200),
        html: commonService.getCodeMsg(props.UICode, CodeId.W201),
        confirmButtonText: '同意',
        cancelButtonText: '不同意',
        showCancelButton: true
      });

      if (isConfirm.dismiss) return;
    }

    // 執行 新增保單資料API
    const tempFill2ndState = { ...props.tempFill2nd.tempFill2ndState } as IFill2ndState;
    // const tempFill1stFormVal = { ...props.tempFill1st.tempFill1stFormVal } as IFill1stFormValue;
    const channelId = storageService.getItem(storageKeys.ChannelId);
    const serverTimeMs = await apiCommonService.fetchSysTime();
    const programId = storageService.getItem(storageKeys.TravelProgramCode);

    // 判斷日期小於當天或日期等於當天但時間小於現在加1小時
    if (moment(editedTempCalc?.tempCalcFormVal?.START_DATE).format('YYYYMMDD') < moment(serverTimeMs).format('YYYYMMDD') ||
      (
        moment(editedTempCalc?.tempCalcFormVal?.START_DATE).format('YYYYMMDD') === moment(serverTimeMs).format('YYYYMMDD') &&
        +moment(editedTempCalc?.tempCalcFormVal?.INSURED_TIME).format('HH') <= +moment(serverTimeMs).format('HH') + 1
      )) {
      sweetAlertService.modal({
        icon: SweetAlertIcon.Info,
        title: '投保時間錯誤',
        html: '投保起始時間最早為現在時間一小時後'
      });
      return;
    }

    const policyAddReq: PolicyAddReq = {
      CHANNEL_ID: channelId || null,
      BC_TYPE: tempFill2ndState.applyType || '',
      APPLY_TIME: commonService.formatUtcTime(serverTimeMs).format('YYYY-MM-DD HH:mm:ss.SSS'),
      APPLY_NO: tempFill2ndState.serialNo,
      PROD_ID: tempFill2ndState.planData?.PROD_ID || '',
      PLAN_ID: tempFill2ndState.planData?.HEADER.PLAN_ID || '',
      PROGRAM_ID: programId || environment.defaultProgramId,
      OPERATOR: props.tempCalcFormVal?.PROGRAM_ID || '',
      SPI_ACTIVITY: editedTempCalc?.tempCalcFormVal?.SPI_TYPE,
      DESTINATION_ID: JSON.stringify(_.map(tempTravels, (travel: TravelWarningExpandData) => travel.COUNTRY_ID)),
      TRAVEL_WARNING_TIME_AFFIRMED: _.some(tempTravels, (travel: TravelWarningExpandData) => travel.WARN_SELECT_TIME) ? commonService.formatUtcTime(_.maxBy(tempTravels, (travel: TravelWarningExpandData) => travel.WARN_SELECT_TIME) as number).format('YYYY-MM-DD HH:mm:ss.SSS') : undefined,
      START_DATE: `${moment(editedTempCalc?.tempCalcFormVal?.START_DATE).format('YYYYMMDD')}`,
      END_DATE: `${moment(editedTempCalc?.tempCalcFormVal?.END_DATE).format('YYYYMMDD')}`,
      START_HOUR: `${moment(editedTempCalc?.tempCalcFormVal?.INSURED_TIME).format('HH')}`,
      TRANSPORT_ID: tempFill1stFormVal?.TRANSPORT || '',
      // 使用快速理賠服務 0-不使用 1-使用
      QUICK_CLAIM_ENABLE: tempFill1stFormVal && tempFill1stFormVal.PROVIDE_INFO && tempFill1stFormVal.PROVIDE_INFO === YesNo.Yes ? '1' : '0',
      QUICK_CLAIM_AGREE_TIME: tempFill1stFormVal && tempFill1stFormVal.PROVIDE_INFO_AGREE_TIME ? moment(tempFill1stFormVal.PROVIDE_INFO_AGREE_TIME).format('YYYY-MM-DD HH:mm:ss.SSS') : undefined,
      AGREE_TIME_TERMS: moment(tempFill1stFormVal?.ALL_CONTRACT_CHECKED_TIME).format('YYYY-MM-DD HH:mm:ss.SSS'),
      ID_TYPE: tempFill2ndFormVal?.NATIONALITY_TYPE || '',
      INSURED_TYPE: tempFill2ndFormVal?.INSURE_SUBJECT || '',
      APPLICANT_NAME: tempFill2ndFormVal?.NAME || '',
      APPLICANT_ID: tempFill2ndFormVal?.MEMBER_ID || '',
      APPLICANT_BIRTHDAY: tempFill2ndFormVal?.BIRTHDAY ? moment(tempFill2ndFormVal?.BIRTHDAY).format('YYYYMMDD') : '',
      APPLICANT_MOBILE: tempFill2ndFormVal?.MOBILE || '',
      APPLICANT_EMAIL: tempFill2ndFormVal?.EMAIL_ADDR || '',
      APPLICANT_POSTCODE: tempFill2ndFormVal?.POST_CODE || '',
      APPLICANT_CITY_ID: tempFill2ndFormVal?.CITY_ID || '',
      APPLICANT_AREA_ID: tempFill2ndFormVal?.AREA_ID || '',
      APPLICANT_ADDRESS: tempFill2ndFormVal?.ADDRESS || '',
      APPLICANT_OCC_DOMAIN: tempFill2ndFormVal?.OCCUPATION_DOMAIN_ID || '',
      APPLICANT_OCCUPATION: tempFill2ndFormVal?.OCCUPATION_ID || '',
      INSURED_UNDER_15: _.filter(tempFill2ndFormVal?.INSUREDS, (insuredState: InsuredState) => insuredState.INSURED_IS_UNDER15).length,
      INSURED_OVER_15: _.filter(tempFill2ndFormVal?.INSUREDS, (insuredState: InsuredState) => !insuredState.INSURED_IS_UNDER15).length,
      POLICY_DELIVERY: tempFill2ndFormVal?.DELIVERY || '',
      CREATE_TIME: `${serverTimeMs}`,
      FLIGHT_SCHEDULE: handleGetFlightSchedule(),
      KYC: handleGetKycInfo(),
      INSURED_LIST: handleGetInsureds()
    };

    console.warn('policyAddReq', policyAddReq);
    // console.warn('tempFill2ndState.planData?.INS_TYPE_ID', tempFill2ndState.planData?.INS_TYPE_ID);
    const insTypeId = tempFill2ndState.planData?.INS_TYPE_ID || '';
    props.onPreviewCheck(insTypeId, policyAddReq);
  };

  /**
   * @description 取得航班資訊
  */
  const handleGetFlightSchedule = () => {
    const flightSchedules = new Array(0);
    if (tempFill1stFormVal && tempFill1stFormVal.FLIGHT_INFOS && tempFill1stFormVal.FLIGHT_INFOS.length > 0) {
      _.forEach(tempFill1stFormVal.FLIGHT_INFOS, (flightInfo: FlightInfo) => {
        _.forEach(flightInfo.SEARCH_RESULT, (flightSchedule: any, fsIndex: number) => {
          if (!flightSchedule.CHECKED) return;
          flightSchedules.push({
            FLIGHT_DATE: moment(flightInfo.FDATE).format('YYYYMMDD'),
            AIRLINE_ID: flightSchedule.carrier,
            FLIGHT_NO: flightSchedule.flightNumber,
            FLIGHT_SEGMENT: String(fsIndex),
            DEPARTURE_TIME: String(moment.tz(flightSchedule.departureTime, "Asia/Taipei").valueOf()),
            DEPARTURE_AIRPORT: flightSchedule.departureAirport,
            ARRIVAL_TIME: String(moment.tz(flightSchedule.arrivalTime, "Asia/Taipei").valueOf()),
            ARRIVAL_AIRPORT: flightSchedule.arrivalAirport
          });
        });
      });
    }

    return flightSchedules;
  };

  /**
   * @description 取得聲明事項資訊
  */
  const handleGetKycInfo = () => {
    if (tempFill2ndFormVal && tempFill2ndFormVal.KYCINFOS && tempFill2ndFormVal.KYCINFOS.length > 0) {
      return _.map(tempFill2ndFormVal.KYCINFOS, (kycInfo: KycInfo) => {
        return {
          KYC_ID: kycInfo.KYC_ID,
          KYC_ANSWER: kycInfo.KYC_ANSWER,
          KYC_OTHER: kycInfo.KYC_OTHER
        };
      });
    }

    return new Array(0);
  };

  /**
   * @description 取得被保險人資訊
  */
  const handleGetInsureds = () => {
    if (tempFill2ndFormVal && tempFill2ndFormVal.INSUREDS && tempFill2ndFormVal.INSUREDS.length > 0) {
      return _.map(tempFill2ndFormVal.INSUREDS, (insured: InsuredState) => {
        return {
          INSURED_ID: insured.INSURED_ID,
          INSURED_NAME: insured.INSURED_NAME,
          RELATIONSHIP: insured.INSURED_RELATION,
          BIRTHDAY: moment(insured.INSURED_BIRTHDAY).format('YYYYMMDD'),
          // CONTRACT_AGE: insured.INSURED_CONTRACT_AGE,
          // 是否小於15歲 1-是 0-否
          UNDER15: insured.INSURED_IS_UNDER15 ? '1' : '0',
          MOBILE: insured.INSURED_MOBILE,
          EMAIL_ADDR: insured.INSURED_EMAIL_ADDR,
          LIFE_AMOUNT: +insured.INSURED_AMT,
          MEDICAL_AMOUNT: isNaN(+insured.INSURED_MEDICAL_VALUE) ? 0 : +insured.INSURED_MEDICAL_VALUE,
          MFUNERAL_AMOUNT: insured.INSURED_IS_UNDER15 ? +insured.INSURED_MFUNERAL : 0,
          // 固定帶1 (法定受益人)
          BENEFICIARY: '1',
          FEE: +insured.INSURED_CALC
        };
      });
    }
    return new Array(0);
  };

  /**
   * @description 取得航班資訊顯示區塊
  */
  const handleCreateFlightInfo = () => {
    const flightNoArray = new Array(0);
    const flichtAreaArray = new Array(0);
    const flightTimeArray = new Array(0);
    _.forEach(tempFill1stFormVal?.FLIGHT_INFOS, (flightInfo: FlightInfo, index: number) => {
      // console.warn("🚀 ~ _.forEach ~ flightInfo:", flightInfo.SEARCH_RESULT);
      _.forEach(flightInfo.SEARCH_RESULT, (flightSchedule: any, fsIndex: number) => {
        if (!flightSchedule.CHECKED) return;
        flightNoArray.push(
          <div
            className="element__list-group-content"
            key={`CARRIER_ID${index}`}
          >
            {`${flightSchedule.carrier}${flightSchedule.flightNumber}`}
          </div>
        );
        flichtAreaArray.push(
          <div
            className="element__list-group-content"
            key={`AIRPORT${index}`}
          >
            {`${flightSchedule.departureAirport}  -  ${flightSchedule.arrivalAirport}`}
          </div>
        );
        flightTimeArray.push(
          <div
            className="element__list-group-content"
            key={`TIME${index}`}
          >
            {`${moment(flightSchedule.departureTime).format('YYYY/MM/DD HH:mm')}  -  ${moment(flightSchedule.arrivalTime).format('YYYY/MM/DD HH:mm')}`}
          </div>
        );
      });
    });

    return (
      <div className="element__list">
        <div className="element__list-col">
          <div className="element__list-group">
            <div className="element__list-group-title">航班資訊</div>
            {flightNoArray}
          </div>
        </div>
        <div className="element__list-col">
          <div className="element__list-group">
            <div className="element__list-group-title">起訖地點</div>
            {flichtAreaArray}
          </div>
        </div>
        <div className="element__list-col">
          <div className="element__list-group">
            <div className="element__list-group-title">出發/抵達時間</div>
            {flightTimeArray}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="insure-process-preview">
      <div className="insure-process-preview__content">
        {
          tempTravels && editedTempCalc ? (
            <div className="travel-info">
              <div className="travel-info__title">旅遊資訊</div>
              <div className="travel-info__content">
                <div className="element__list">
                  <div className="element__list-col">
                    <div className="element__list-group">
                      <div className="element__list-group-title">方案</div>
                      <div className="element__list-group-content">{editedTempCalc.planData?.HEADER?.TITLE}</div>
                    </div>
                  </div>
                  <div className="element__list-col">
                    <div className="element__list-group">
                      <div className="element__list-group-title">保險期間</div>
                      <div className="element__list-group-content">
                        {
                          `${moment(editedTempCalc.tempCalcFormVal?.START_DATE).format('YYYY/MM/DD')} 
                          ${moment(editedTempCalc.tempCalcFormVal?.INSURED_TIME).format('HH:00')} ~ 
                          ${moment(editedTempCalc.tempCalcFormVal?.END_DATE).format('YYYY/MM/DD')} 
                          ${moment(editedTempCalc.tempCalcFormVal?.INSURED_TIME).format('HH:00')}
                          ，共投保${(moment(moment(editedTempCalc.tempCalcFormVal?.END_DATE).format('YYYY/MM/DD'))
                          .diff(moment(editedTempCalc.tempCalcFormVal?.START_DATE).format('YYYY/MM/DD'), 'd'))}天`
                        }
                      </div>
                    </div>
                  </div>
                  <div className="element__list-col">
                    <div className="element__list-group">
                      <div className="element__list-group-title">旅遊/活動地點</div>
                      <div className="element__list-group-content">
                        {
                          _.reduce(_.map(tempTravels, (travel: TravelWarningExpandData) => travel.COUNTRY_NAME as string), (res: string, country: string) => {
                            return `${res} ${country}`;
                          })
                        }
                        {
                          // tempFill1stFormVal && tempFill1stFormVal.TOURIST_MOUNTAIN
                          //   ? ` / ${tempFill1stFormVal.TOURIST_MOUNTAIN}`
                          //   : null
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null
        }
        {
          tempFill1stFormVal?.FLIGHT_INFOS && tempFill1stFormVal.FLIGHT_INFOS.length > 0 ? (
            <div className="flight-info">
              <div className="flight-info__title">航班資訊</div>
              <div className="flight-info__content">
                {
                  handleCreateFlightInfo()
                }
              </div>
            </div>
          ) : null
        }
        {
          tempFill2ndFormVal && planDataFooter ? (
            <>
              <div className="policyholder-info">
                <div className="policyholder-info__title">要保人資料(含要保人聲明)</div>
                <div className="policyholder-info__content">
                  <div className="element__list">
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">要保人姓名</div>
                        <div className="element__list-group-content">{tempFill2ndFormVal.NAME}</div>
                      </div>
                    </div>
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">身分證字號</div>
                        <div className="element__list-group-content">{tempFill2ndFormVal.MEMBER_ID}</div>
                      </div>
                    </div>
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">出生年月日</div>
                        <div className="element__list-group-content">{moment(tempFill2ndFormVal.BIRTHDAY).format('YYYY/MM/DD')}</div>
                      </div>
                    </div>
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">手機</div>
                        <div className="element__list-group-content">{tempFill2ndFormVal.MOBILE}</div>
                      </div>
                    </div>
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">電子信箱</div>
                        <div className="element__list-group-content">{tempFill2ndFormVal.EMAIL_ADDR}</div>
                      </div>
                    </div>
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">通訊地址</div>
                        <div className="element__list-group-content">
                          {
                            `${tempFill2ndFormVal.POST_CODE}${commonService.getCityName(props.postcodes, tempFill2ndFormVal.CITY_ID)}${commonService.getAreaName(props.postcodes, tempFill2ndFormVal.CITY_ID, tempFill2ndFormVal.AREA_ID)}${tempFill2ndFormVal.ADDRESS}`
                          }
                        </div>
                      </div>
                    </div>
                    <div className="element__list-col">
                      <div className="element__list-group">
                        <div className="element__list-group-title">職業類別</div>
                        <div className="element__list-group-content">
                          {
                            tempFill2ndFormVal.OCCUPATION_DOMAIN_ID === OccupationIdType.Special
                              ? `${tempFill2ndFormVal.OCCUPATION_DOMAIN_ID_NAME}/${tempFill2ndFormVal.OCCUPATION_ID_NAME}`
                              : `${tempFill2ndFormVal.OCCUPATION_DOMAIN_ID_NAME}`
                          }
                        </div>
                      </div>
                    </div>
                    {
                      tempFill2ndFormVal.KYCINFOS && tempFill2ndFormVal.KYCINFOS.length > 0 && (
                        _.map(tempFill2ndFormVal.KYCINFOS, (info: any, index: number) => {
                          return (
                            <div className="element__list-col" key={index}>
                              <div className="element__list-group">
                                <div className="element__list-group-title">{info.KYC_SUBJECT}</div>
                                <div className="element__list-group-content">
                                  {
                                    info.KYC_ANSWER === '99'
                                      ? `${info.KYC_ANSWER_TEXT} ${info.KYC_OTHER}`
                                      : `${info.KYC_ANSWER_TEXT}`
                                  }
                                </div>
                              </div>
                            </div>
                          );
                        })
                      )
                    }
                  </div>
                </div>
              </div>
              <div className="insured-info">
                <div className="insured-info__title">被保險人資料</div>
                <div className="insured-info__content">
                  {
                    _.map(tempFill2ndFormVal.INSUREDS, (insured: InsuredState, index: number) => {
                      return (
                        <div className="element__list" key={index}>
                          <div className="element__list-col">
                            <div className="element__list-group">
                              <div className="element__list-group-title">被保險人姓名</div>
                              <div className="element__list-group-content">{insured.INSURED_NAME}</div>
                            </div>
                          </div>
                          <div className="element__list-col">
                            <div className="element__list-group">
                              <div className="element__list-group-title">被保險人為要保人之</div>
                              <div className="element__list-group-content">{insured.INSURED_RELATION_NAME}</div>
                            </div>
                          </div>
                          <div className="element__list-col">
                            <div className="element__list-group">
                              <div className="element__list-group-title">身分證字號</div>
                              <div className="element__list-group-content">{insured.INSURED_ID}</div>
                            </div>
                          </div>
                          <div className="element__list-col">
                            <div className="element__list-group">
                              <div className="element__list-group-title">出生年月日</div>
                              <div className="element__list-group-content">{moment(insured.INSURED_BIRTHDAY).format('YYYY年MM月DD日')}</div>
                            </div>
                          </div>
                          <div className="element__list-col">
                            <div className="element__list-group">
                              <div className="element__list-group-title">{insured.INSURED_IS_UNDER15 ? '意外失能' : '意外身故及失能'}</div>
                              <div className="element__list-group-content">{insured.INSURED_AMT_NAME}</div>
                            </div>
                          </div>
                          {
                            insured.INSURED_IS_UNDER15 &&
                              <div className="element__list-col">
                                <div className="element__list-group">
                                  <div className="element__list-group-title">喪葬費用</div>
                                  <div className="element__list-group-content">{commonService.handleConvertAmount(String(insured.INSURED_MFUNERAL))}</div>
                                </div>
                              </div>
                          }
                          <div className="element__list-col">
                            <div className="element__list-group">
                              <div className="element__list-group-title">實支實付醫療</div>
                              <div className="element__list-group-content">{commonService.handleConvertAmount(insured.INSURED_MEDICAL_VALUE)}</div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
              <div className="payment-amount">
                <div className="payment-amount__title">繳費金額</div>
                <div className="payment-amount__content">
                  <div className="payment-amount__item">
                    <span>15歲以上投保方案({tempFill2ndFormVal.INSUREDS.filter(item => item.INSURED_IS_UNDER15 === false).length}位)</span>
                    <span>NT$ {commonService.thousandFormat(String(tempFill2ndFormVal.INSUREDS.filter(item => item.INSURED_IS_UNDER15 === false).reduce((acc, cur) => acc + parseInt(cur.INSURED_CALC), 0)))} 元</span>
                  </div>
                  <div className="payment-amount__item">
                    <span>未滿15歲投保方案({tempFill2ndFormVal.INSUREDS.filter(item => item.INSURED_IS_UNDER15 === true).length}位)</span>
                    <span>NT$ {commonService.thousandFormat(String(tempFill2ndFormVal.INSUREDS.filter(item => item.INSURED_IS_UNDER15 === true).reduce((acc, cur) => acc + parseInt(cur.INSURED_CALC), 0)))} 元</span>
                  </div>
                  {
                    _.map(planDataFooter, (footer: ExpanFooterContent, index: number) => {
                      return (
                        <div className="payment-amount__item" key={index}>
                          <span>{footer.TITLE}</span>
                          <span>{footer.TOTAL.replace(/(.*\s)([\d]{0,})(\s元)/, `$1${commonService.thousandFormat(footer.TOTAL.replace(/.*\s([\d]{0,})\s元/, '$1'))}$3`)}</span>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            </>
          ) : null
        }
      </div>
      <div className="insure-process-preview__controls">
        <button type="button" className="element__button element__button--red-border" onClick={props.onGoBack}>返回上一頁</button>
        <button type="button" className="element__button element__button--red" onClick={handleOnClick}>下一步</button>
      </div>
    </div>
  );
};

export default InsureProcessPreview;
